import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { escapeJsx } from '@cli-utils/text.js'
import { hasVisibleLabel } from './has-visible-label.js'

export function formLabel(field: SchemaField, text: string): string {
  const safeText = escapeJsx(text)
  return hasVisibleLabel(field)
    ? `<FormLabel>${safeText}</FormLabel>`
    : `<FormLabel className="sr-only">${safeText}</FormLabel>`
}
